window.addEventListener('load', () => {
  if (document.querySelector('.mod-screen-rotation')) {
    document.body.classList.add('has-screen-rotation');
  }
});
